import React from 'react';
import { PublicComments } from 'components/project/FloorBidderScreen';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: comments;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  font-size: min(2vw, 3em);
  text-overflow: ellipsis;
`;

const PublicCommentsContainer = () => {
  return (
    <Container>
      <PublicComments noCommentsText="No comments" />
    </Container>
  );
};

export default PublicCommentsContainer;
